import SvgIcon from './src/components/svg-icon'
import QunjiInput from './src/components/input'
import QunjiSpan from './src/components/span'
import QunjiSelect from './src/components/select'
import QunjiDate from './src/components/date'
import QunjiButton from './src/components/button'
import './src/icons'

export default {
  install: function (Vue) {
    if (typeof window !== 'undefined' && window.Vue) {
      Vue = window.Vue
    }
    Vue.component('SvgIcon', SvgIcon)
    Vue.component('QunjiInput', QunjiInput)
    Vue.component('QunjiSpan', QunjiSpan)
    Vue.component('QunjiSelect', QunjiSelect)
    Vue.component('QunjiDate', QunjiDate)
    Vue.component('QunjiButton', QunjiButton)
  }
}
